var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"mr-2 alignchip",attrs:{"small":"","label":"","close":_vm.close,"target":"_blank","color":_vm.color,"href":_vm.file.fileurl},on:{"click:close":function($event){return _vm.handleClose()}}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v(" fas fa-paperclip ")]),_vm._v(" "+_vm._s(_vm.file.filename)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }